<template>
	<div>
		<table class="table table-striped table-bordered">
			<thead>
				<tr>
					<th>Cod</th>
					<th>Usuário</th>
					<th>Data</th>
					<th>Total</th>
					<th>Ação</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="dIn.history && dIn.history.length > 0">
					<tr v-for="(item, index) in dIn.history" :key="index">
						<td>{{ item.cod }}</td>
						<td>
							{{ item.uid.nome || 'ViaMed' }}
							{{ item.uid.sobrenome }}
						</td>
						<td>{{ item.evento }}</td>
						<td>R$ {{ item.total_prop }}</td>
						<td>
							<button
								@click="reverter(item)"
								class="btn btn-warning btn-xs"
							>
								Reverter
							</button>
						</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>
<script>
	import WBS from 'js/http';

	export default {
		name: 'history',
		props: ['dIn', 'assets'],
		methods: {
			reverter(item) {
				WBS.send('private-save-sstPropostalsBack', item, (resp) => {
					if (resp.status == 'success' && resp.data != undefined) {
						this.dIn.history = resp.data.dataHistory;
						this.$emit('update:assets', resp.data.dataProposta);
					}
				});
			},
		},
		computed: {},
	};
</script>



// WEBPACK FOOTER //
// src/components/proposals/components/components/history.vue